function convertStringToSearchable(string) {
  return string && typeof string === 'string'
    ? string.replace(/[^a-z0-9\u0400-\u04FF]/gi, '').toLowerCase()
    : undefined;
}

export default convertStringToSearchable;
